import { fetchRewardsRules, createRewardsRule } from '@/api/rewards-rule'
import { useAuthQuery } from '@/hooks/use-auth-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { DEFAULT_PER_PAGE } from '@/data/constants'

export const useFetchRewardsRules = ({
  page = 1,
  perPage = DEFAULT_PER_PAGE,
  sortBy = 'startDate',
  fields = null,
  searchValue = null,
  orderBy = null,
} = {}) => {
  return useAuthQuery({
    queryKey: ['rewardsRule', page, perPage, sortBy, fields, searchValue, orderBy],
    queryFn: () => fetchRewardsRules(page, perPage, sortBy, fields, searchValue, orderBy),
    keepPreviousData: true,
    onError: error => {
      console.error('Error fetching rewards rules:', error.message)
    },
  })
}

export function useCreateRule() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['createRule'],
    mutationFn: createRewardsRule,
    onMutate: async newRuleData => {
      const previousRules = queryClient.getQueryData(['ruleData'])
      queryClient.setQueryData(['ruleData'], (current = []) => [...current, newRuleData])
      return { previousRules }
    },
    onError: context => {
      queryClient.setQueryData(['ruleData'], context.previousRules)
    },
    onSettled: () => {
      queryClient.invalidateQueries(['ruleData'])
    },
  })
}
